<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter1"><a id="ch00_fm06_ded"></a><a id="page_ix"></a><em>as a prayer</em><br/><em>for Love<br/>to be forgiven</em> <a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_ded.vue?84ddf9b6